import { ActionTree } from 'vuex';
import { IRootState } from '@/store/types';
import { IState } from './types';
import { profile } from '@/server/model/sys';
const actions: ActionTree<IState, IRootState> = {
  async profile({ commit }) {
    const res = await profile();
    commit('setUserInfo', res);
  }
};
export default actions;
